import { render } from "./HeaderNewTile.vue?vue&type=template&id=5ab2adb9&scoped=true"
import script from "./HeaderNewTile.vue?vue&type=script&lang=js"
export * from "./HeaderNewTile.vue?vue&type=script&lang=js"

import "./HeaderNewTile.vue?vue&type=style&index=0&id=5ab2adb9&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab2adb9"]])

export default __exports__